import React from "react";
import { Container } from "@chakra-ui/react";
import ListLanguage from "views/admin/Language/components/ListLanguage";

const Language = () => {
  return (
    <Container maxW="xxl" mt={100} p={{ base: 4, md: 8 }}>
      <ListLanguage />
    </Container>
  );
};

export default Language;
